import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfService } from 'src/conf.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiConfig } from 'src/app/config/apiConfig';

@Injectable({
  providedIn: 'root'
})

export class LabActionItemService {
  private rootUrl: string;
  private labActionItemAPIUrl;
  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.labActionItemAPIUrl = ApiConfig.LabActionItemApiConfig;
  }
  
  getNoLabRequestActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getNoLabRequestActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabActionItemTabDetails(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getLabActionItemTabDetails}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getOverdueActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getOverdueActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getRedrawActionItems(ObjParam: any): Observable<any> {
   
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getRedrawActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getUpcomingLabActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getUpcomingLabActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getUnmappedLabTestActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getUnmappedLabTestActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getLabAlertActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getLabAlertActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
  getMissingDrawDateActionItems(ObjParam: any): Observable<any> {
    return this.http.post(`${this.rootUrl}${this.labActionItemAPIUrl.getMissingDrawDateActionItems}`, ObjParam)
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
